export default __webpack_public_path__ + "03ebaf09b96d705f00372dbba353efd5.svg";